<template>
    <div class="w-full border-b border-gray-400" :class="{'tabs-page-header-fixed' : fixed}">
        <ul class="list-none flex -mb-px pt-2" :class="[ dynamic ? 'pl-6' : '' ]">
            <li class="mr-1"
                :class="{'-mb-px': selectedTab === tab.slug}"
                v-for="(tab, index) in filteredTabs"
                :key="index">
                <a href="javascript:void(0)"
                    class="inline-block py-2 px-2 no-underline text-gray-800 px-6 text-sm border-t-2 border-l border-r"
                    :class="{'bg-tab-content': selectedTab === tab.slug, 'header-bg border-transparent hover:bg-gray-100': selectedTab !== tab.slug}"
                    @click="setActiveTab(tab.slug)">
                    {{ tab.name }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            tabs: {
                default: () => [],
                type: Array
            },
            active: {
                default: null,
                type: String
            },
            display: {
                default: ''
            },
            dynamic: {
                default: true
            },
            fixed: {
                default: false,
                type: Boolean
            }
        },
        data: function(){
            return {
                selectedTab: null
            }
        },
        beforeMount() {
            if (this.tabs.length > 0){
                if (!this.active){
                    this.selectedTab = this.tabs[0].slug;
                } else {
                    this.selectedTab = this.active;
                }

                if (this.dynamic) {
                    let windowLocationHash = window.location.hash.replace('#', '');

                    if (windowLocationHash) {
                        this.selectedTab = windowLocationHash;
                    }
                }

                this.$emit('setTab', this.selectedTab);
            }
        },
        methods: {
            setActiveTab: function(tab){
                if (this.selectedTab !== tab) {
                    this.selectedTab = tab;
                    this.$emit('setTab', this.selectedTab);
                    if (this.dynamic) {
                        if (!this.$store.getters.redirect) {
                            this.$router.push(document.location.pathname + '#' + tab);
                        } else {
                            history.replaceState(null, null, document.location.pathname + '#' + tab);
                        }
                    }
                }
            },
            displayTab (tab) {
                if (tab.display === false){
                    return false;
                }

                if (this.display !== null && typeof this.display === 'object'){
                    if (tab.display){
                        if (this.display){
                            return this.display.toLowerCase() === tab.display.toLowerCase();
                        }
                        return false;
                    }
                }
                return true;
            }
        },
        computed: {
            filteredTabs () {
                return this.tabs.filter((tab) => {
                    return this.displayTab(tab);
                });
            }
        },
        watch: {
            tabs: function(newVal){
                if (this.tabs.length > 0){
                    if (!this.active){
                        this.selectedTab = this.tabs[0].slug;
                    } else {
                        this.selectedTab = this.active;
                    }

                    if (this.dynamic) {
                        let windowLocationHash = window.location.hash.replace('#', '');

                        if (windowLocationHash) {
                            this.selectedTab = windowLocationHash;
                        }
                    }

                    this.$emit('setTab', this.selectedTab);
                }
            }
        }
    }
</script>
